<p-card>
  <div class="mb-3"><strong>Insect Variant / Growth Stage</strong></div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #insectVariantSelect
          appLockInitialWidth
          fluid="true"
          inputId="insectVariant"
          [(ngModel)]="insectItem.insectVariantId"
          [options]="distinctInsectVariants"
          data-testid="insectVariant"
          optionLabel="displayName"
          optionValue="insectVariantId"
          class="required"
          [disabled]="editingInstance"
          appendTo="body"
          (onChange)="mapGrowthStages($event)">
        </p-select>
        <label for="insectVariant">Insect Variant</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #growthStageSelect
          appLockInitialWidth
          fluid="true"
          inputId="growthStage"
          [(ngModel)]="insectItem.insectGrowthStageId"
          [options]="insectGrowthStages"
          data-testid="insectGrowthStage"
          optionLabel="name"
          optionValue="insectGrowthStageId"
          class="required"
          appendTo="body"
          (onChange)="emitInsectItem()"
          [disabled]="growthStageDisabled || editingInstance"></p-select>
        <label for="growthStage">Growth Stage</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-inputnumber
          [(ngModel)]="insectItem.quantity"
          class="width-6 required"
          [useGrouping]="false"
          inputId="quantity"
          data-testid="quantity"
          (onInput)="emitInsectItem()" />
        <label for="quantity">Quantity</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #permitSelect
          appLockInitialWidth
          fluid="true"
          [(ngModel)]="insectItem.permitId"
          [options]="permits"
          inputId="permits"
          data-testid="insectPermit"
          optionLabel="name"
          optionValue="id"
          filter="true"
          appendTo="body"
          filterPlaceholder="Search Permit"
          class="required"
          (onChange)="emitInsectItem()"></p-select>
        <label for="permits">Permit</label>
      </p-floatlabel>
    </div>
  </div>
</p-card>
